import config from 'react-global-configuration';

import {
  setOperationStatus,
  UI_OPERATION_STATUS_REQUEST,
  UI_OPERATION_STATUS_SUCCESS,
  UI_OPERATION_STATUS_ERROR,
  userGetCurrent,
} from '@uncinc/react-drupal-core';
import { userGetLoaded } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/User';

import { gtm } from '@uncinc/uncinc-react-kitchen-sink';

import { nursePractitionerUnpaired } from '../NursePractitioner';
import {
  getRegistrationData,
  initializeRegistrations,
  reinitializeRegistrationData,
} from '../Registrations';

export const userRegisterAsNursePractitioner = ({ email, password, ...values }) => {
  const body = {
    mail: email,
    name: email,
    pass: password,
    ...values,
  };

  let processedBody = {};

  for (const key in body) {
    processedBody[key] = [
      {
        value: body[key],
      },
    ];
  }

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_REQUEST));
      const API_URL = config.get('API_URL');
      fetch(`${API_URL}/user/register?_format=json`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(processedBody),
      }).then((response) => {
        if (response.ok) return response.json();
        else throw new Error();
      }).then((jsonResponse) => {
        dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_SUCCESS));
        resolve(jsonResponse);
      }).catch((err) => {
        dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_ERROR));
        reject(err);
      });
    });
  };
};

export const userPairWithNursePractitioner = (pairing_code) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/proxy/pair-poh`, {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify({
              pairing_code,
            }),
          })
            .then((response) => {
              if (response.ok) {
                dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_SUCCESS));
                dispatch(userGetCurrent());
                dispatch(getRegistrationData());
                resolve();
              } else {
                throw new Error();
              }
            })
            .catch((error) => {
              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
              reject(error);
            });
        })
        .catch(() => {
          dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
        });
    });
  };
};

export const userUnpairWithNursePractitioner = () => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          return fetch(`${PATH}/unpair-user-poh-proxy`, {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          });
        }).then(async (res) => {
          if (!res.ok) throw new Error();
          dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_SUCCESS));
          dispatch(userGetCurrent());
          dispatch(getRegistrationData());
          dispatch(nursePractitionerUnpaired());
          resolve();
        })
        .catch((err) => {
          dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });

  };
};

export const userUpdate = (userId, values) => {
  const API_URL = config.get('API_URL');
  let csrfToken;

  return (dispatch) => {
    dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/rest/session/token`, { credentials: 'include' })
        .then((response) => response.text())
        .then((response) => {
          csrfToken = response;
          fetch(`${API_URL}/user/${userId}`, {
            method: 'PATCH',
            credentials: 'include',
            body: JSON.stringify(values),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) return response.json();

              // Parse error response to include error details
              return response.json().then(
                (errorData) => {
                  const error = new Error(errorData.message || 'Request failed');
                  error.status = response.status;
                  error.statusText = response.statusText;
                  error.drupalError = errorData;
                  throw error;
                },
                (parseError) => {
                  // Fallback if JSON parsing fails
                  const error = new Error('Request failed');
                  error.status = response.status;
                  error.statusText = response.statusText;
                  throw error;
                },
              );
            })
            .then((response) => {
              // Update user object.
              dispatch(userGetLoaded(userId, response));

              // Re-initialize registrations
              dispatch(initializeRegistrations(
                response.field_registrations_start_date[0].value,
                response.field_program_start_date[0].value,
              ));

              // Refresh the daily registrations and exercises.
              dispatch(reinitializeRegistrationData());

              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_SUCCESS));
              resolve();
            })
            .catch((err) => {
              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
              reject(err);
            });
        })
        .catch((err) => {
          dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
};

export const userUnRegisterPushNotificationToken = (pushNotificationToken) => {
  const API_URL = config.get('API_URL');
  let csrfToken;

  return (dispatch) => {
    dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/rest/session/token`, { credentials: 'include' })
        .then((response) => response.text())
        .then((response) => {
          csrfToken = response;
          fetch(`${API_URL}/api/push-notification-token`, {
            method: 'DELETE',
            credentials: 'include',
            body: JSON.stringify({ pushNotificationToken }),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) return response.json();
              else throw new Error();
            })
            .then((response) => {
              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_SUCCESS));
              resolve();
            })
            .catch((err) => {
              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
              reject(err);
            });
        })
        .catch((err) => {
          dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
};

export const userRegisterPushNotificationToken = (pushNotificationToken) => {
  const API_URL = config.get('API_URL');
  let csrfToken;

  return (dispatch) => {
    dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/rest/session/token`, { credentials: 'include' })
        .then((response) => response.text())
        .then((response) => {
          csrfToken = response;
          fetch(`${API_URL}/api/push-notification-token`, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({ pushNotificationToken }),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) return response.json();
              else throw new Error();
            })
            .then((response) => {
              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_SUCCESS));
              resolve();
            })
            .catch((err) => {
              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
              reject(err);
            });
        })
        .catch((err) => {
          dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
};

export const userRemoveAccount = () => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_REQUEST));

    fetch(`${PATH}/rest/session/token?_format=json`, {
      credentials: 'include',
    })
      .then((response) => response.text())
      .then((response) => {
        const csrfToken = response;

        fetch(`${PATH}/delete-user-account`, {
          method: 'POST',
          credentials: 'include',
          body: JSON.stringify({}),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        })
          .then((response) => {
            if (response.ok) return response.json();
            else throw new Error();
          })
          .then(() => {
            dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_SUCCESS));

            // Push new user delete account event to GTM.
            gtm.trackUserEvent('user', 'delete_user_account');
          }).catch(() => {
            dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
          });
      })
      .catch(() => {
        dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
      });
  };
};

export const userRestartProgram = () => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/reset-progress`, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({}),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) return response.json();
              else throw new Error();
            })
            .then(() => {
              // Update user object.
              dispatch(userGetCurrent());
              // Refresh the daily registrations and exercises.
              dispatch(reinitializeRegistrationData());

              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_SUCCESS));

              // Push new user reset progress event to GTM.
              gtm.trackUserEvent('user', 'reset_progress');

              resolve();
            }).catch((error) => {
              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
              reject(error);
            });
        })
        .catch((error) => {
          dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
          reject(error);
        });
    });
  };
};

// Buddy actions.
export const userAddBuddy = (name, email) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/buddy/add`, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({
              name,
              email,
            }),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) return response.json();
              else throw new Error();
            })
            .then(() => {
              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_SUCCESS));
              dispatch(userGetCurrent());

              // Push new add buddy event to GTM.
              gtm.trackUserEvent('user', 'add_buddy');

              resolve();
            }).catch((error) => {
              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
              reject(error);
            });
        })
        .catch((error) => {
          dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
          reject(error);
        });
    });
  };
};

export const userDeleteBuddy = (buddyId) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('user', 'delete_buddy', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/buddy/delete`, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({
              buddy_id: buddyId,
            }),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) return response.json();
              else throw new Error();
            })
            .then((response) => {
              dispatch(setOperationStatus('user', 'delete_buddy', UI_OPERATION_STATUS_SUCCESS));
              dispatch(userGetCurrent());
              resolve();
            }).catch((error) => {
              dispatch(setOperationStatus('user', 'delete_buddy', UI_OPERATION_STATUS_ERROR));
              reject(error);
            });
        })
        .catch((error) => {
          dispatch(setOperationStatus('user', 'delete_buddy', UI_OPERATION_STATUS_ERROR));
          reject(error);
        });
    });
  };
};

export const validateEmail = (uid, timestamp, hash) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('user', 'validate_email', UI_OPERATION_STATUS_REQUEST));

    fetch(`${PATH}/rest/session/token?_format=json`, {
      credentials: 'include',
    })
      .then((response) => response.text())
      .then((response) => {
        const csrfToken = response;

        fetch(`${PATH}/validate-email`, {
          method: 'POST',
          credentials: 'include',
          body: JSON.stringify({
            uid: uid,
            timestamp: timestamp,
            hash: hash,
          }),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        })
          .then((response) => {
            if (response.ok) {
              dispatch(setOperationStatus('user', 'validate_email', UI_OPERATION_STATUS_SUCCESS));
              return response.json();
            }
            else {
              dispatch(setOperationStatus('user', 'validate_email', UI_OPERATION_STATUS_ERROR));
              throw new Error();
            }
          })
          .catch((error) => {
            dispatch(setOperationStatus('user', 'validate_email', UI_OPERATION_STATUS_ERROR));
            console.error(error);
          });
      })
      .catch((error) => {
        dispatch(setOperationStatus('user', 'validate_email', UI_OPERATION_STATUS_ERROR));
        console.error(error);
      });
  };
};

export const sendValidationEmail = () => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('user', 'send_validation_email', UI_OPERATION_STATUS_REQUEST));

    fetch(`${PATH}/rest/session/token?_format=json`, {
      credentials: 'include',
    })
      .then((response) => response.text())
      .then((response) => {
        const csrfToken = response;

        fetch(`${PATH}/send-validation-email`, {
          method: 'POST',
          credentials: 'include',
          body: JSON.stringify({}),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        })
          .then((response) => {
            if (response.ok) {
              dispatch(setOperationStatus('user', 'send_validation_email', UI_OPERATION_STATUS_SUCCESS));
              return response.json();
            }
            else {
              dispatch(setOperationStatus('user', 'send_validation_email', UI_OPERATION_STATUS_ERROR));
              throw new Error();
            }
          })
          .catch((error) => {
            dispatch(setOperationStatus('user', 'send_validation_email', UI_OPERATION_STATUS_ERROR));
            console.error(error);
          });
      })
      .catch((error) => {
        dispatch(setOperationStatus('user', 'send_validation_email', UI_OPERATION_STATUS_ERROR));
        console.error(error);
      });
  };
};

export const userUpdateWithHti = (userId, values) => {
  const API_URL = config.get('API_URL');
  let csrfToken;

  return (dispatch) => {
    dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/rest/session/token`, { credentials: 'include' })
        .then((response) => response.text())
        .then((response) => {
          csrfToken = response;
          fetch(`${API_URL}/zelfhulp-hti/update-user`, {
            method: 'PATCH',
            credentials: 'include',
            body: JSON.stringify(values),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) return response.json();
              else throw new Error();
            })
            .then((response) => {
              // Update user object.
              dispatch(userGetLoaded(userId, response));

              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_SUCCESS));
              resolve();
            })
            .catch((err) => {
              dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
              reject(err);
            });
        })
        .catch((err) => {
          dispatch(setOperationStatus('user', 'update', UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
};
